<template>
	<div>
		<span class="spanlabel">{{OrderName}}</span>
		<span class="spanlabel">总已检：{{checkednum}}人；待检：{{nochecknum}}人</span>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="图表明细" name="tab1">
				<OrderCheckChart v-if="showtab1" :inordercuss="OrderCusList"></OrderCheckChart>
			</el-tab-pane>

			<el-tab-pane label="数据明细" name="tab2">
				<OrderCheckData v-if="showtab2" :inordercuss="OrderCusList"></OrderCheckData>
			</el-tab-pane>
		</el-tabs>

	</div>
</template>

<script>
	import ordercus from '../../apifunction/OrderCus.js'
	import OrderCheckChart from './OrderCheckChart.vue'
	import OrderCheckData from './OrderCheckData.vue'
	export default {
		created() {
			var ent = this.$route.query.ent;
			this.orderent = JSON.parse(ent);
			this.InitData();
		},
		components: {
			OrderCheckChart,
			OrderCheckData
		},
		data() {
			return {
				orderent: null,
				OrderName: "",
				OrderCusList: [],
				checkednum: 0,
				nochecknum: 0,
				activeName: 'tab1',
				showtab1: true,
				showtab2: false
			}
		},
		methods: {
			InitData() {

				this.OrderName = this.orderent.OrderName;
				ordercus.GetOrderCusByOrder(this.orderent.OrderID)
					.then(res1 => {
						let ent1 = JSON.parse(JSON.stringify(res1.data))
						if (ent1.Flag == 'success') {
							this.OrderCusList = JSON.parse(ent1.Data)
							if (this.OrderCusList.length > 0) {
								this.checkednum = 0;
								this.nochecknum = 0;
								for (let i = 0; i < this.OrderCusList.length; i++) {
									if (this.OrderCusList[i].cusstatus >= 50)
										this.checkednum++;
									else
										this.nochecknum++;
								}
							}
						} else
							this.$message.info(ent.Msg);
					});
			},
			handleClick() {
				if (this.activeName == "tab1") {
					this.showtab1 = true;
					this.showtab2 = false;
				} else {
					this.showtab1 = false;
					this.showtab2 = true;
				}
			}
		}
	}
</script>

<style>
</style>
